import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { MatFormFieldControl } from '@angular/material/form-field';
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
} from '@angular/material/core';
import { CustomDateAdapter } from 'src/app/adapters/customdate.adapter';
import {
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
  MAT_MOMENT_DATE_FORMATS,
} from '@angular/material-moment-adapter';
import { Mission } from 'src/app/models/mission';
import { DataService } from 'src/app/services/data.service';
import { ValueList } from 'src/app/models/ValueList';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { OptionColumns } from 'src/app/components/forms/autocomplete-field/autocomplete-field.component';
import * as moment from 'moment';

@Component({
  selector: 'app-mission-dialog',
  templateUrl: './mission-dialog.component.html',
  styleUrls: ['./mission-dialog.component.scss'],
  providers: [
    { provide: MatFormFieldControl, useExisting: MissionDialog },
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.
    {
      provide: DateAdapter,
      useClass: CustomDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },

    { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
  ],
})


export class MissionDialog implements OnInit {
  public ready = false;
  public btn_save_disabled = false;
  public btn_save_loader = false;
  public form: FormGroup;
  public type: ValueList = null;
  public user_level: { value: string, viewValue: string }[] = [];
  public mission: Mission = null;
  public isAdmin: boolean = false;
  public startDate = null;
  public endDate = null;
  public onUpdate = false;

  public editorOptions = {
    toolbar: [
      ['bold', 'italic', 'underline'],
      [{ 'header': 1 }, { 'header': 2 }],
      [{ 'list': 'ordered' }, { 'list': 'bullet' }],
      [{ 'color': [] }],
    ]
  };

  public usersOptionsColumns: OptionColumns = {
    id: 'id',
    label: 'firstname',
    operator: 'contain'
  };

  constructor(
    public dialogRef: MatDialogRef<MissionDialog>,
    public translate: TranslateService,
    public auth: AuthenticationService,
    public dataService: DataService,
    @Inject(MAT_DIALOG_DATA) public data
  ) {
    this.startDate = moment().add(1, 'm');
    this.endDate = moment(this.startDate).add(1, 'd');
    // create formgroup
    this.form = new FormGroup(
      {
        title: new FormControl('', [Validators.required]),
        user_id: new FormControl(null),
        start_date: new FormControl(this.startDate),
        end_date: new FormControl('', [Validators.required]),
        description: new FormControl(null),
        status: new FormControl('new'),
        type: new FormControl(null),
        user_level: new FormControl('level_1'),
		is_model: new FormControl(false),
        require_photo_certification: new FormControl(false),
      },
      {
        updateOn: 'change',
      }
    );

    console.log('dialog data = ', data);

  }

  ngOnInit(): void {
    let proms = [];

    if (this.auth.getCurrentAuthUser().hasRole(['super-admin'])) {
      this.form.controls['user_id'].setValidators([Validators.required]);
    } else {
      this.form.controls['is_model'].disable();
      this.form.controls['require_photo_certification'].disable();
    }

    this.user_level = [
      { value: 'level_1', viewValue: this.translate.instant('MISSIONS.MISSION_DIALOG.LEVEL_1') },
      { value: 'level_2', viewValue: this.translate.instant('MISSIONS.MISSION_DIALOG.LEVEL_2') },
    ];

    proms.push(this.dataService.getListData('mission_type').then(list => {
      this.type = list;
      this.ready = true;
    }).catch(err => {
      console.log(err);
    }));

    if (this.data && this.data.item) {
    
      this.mission = this.data.item;
      this.form.patchValue(this.mission);

      if(this.mission && this.data?.isAdmin && (this.mission.status == 'validated' || this.mission.status == 'pending')){
        this.onUpdate = true;
      }

      this.startDate = this.form.get('start_date').value ? this.form.get('start_date').value : this.startDate;
      this.endDate = moment(this.startDate).add(1, 'd');

      if (this.mission?.status != 'new' && !this.auth.getCurrentAuthUser().hasRole(['super-admin'])) {
        this.form.get('user_level').disable();
      }

      if (this.mission.user) {
        this.form.controls['user_id'].patchValue({
          id: this.mission.user_id,
          label: this.mission.user.firstname + ' ' + this.mission.user.lastname
        });
      }
    }
  }

  save() {
    this.form.markAllAsTouched();
    if (this.mission) {
      this.update(this.mission);
    } else {
      this.create();
    }
  }

  create() {
    if (this.form.valid) {
      this.btn_save_disabled = true;
      this.btn_save_loader = true;

      let data = this.form.value;

      this.dataService.postAsPromise('admin/missions', data).then(res => {
        if (res && res.data) {
          this.dialogRef.close({ mission: res.data, mode: 'new' });
        } else {
          this.dialogRef.close('bt_save');
        }
        this.btn_save_disabled = false;
        this.btn_save_loader = false;
      }).catch(err => {
        this.btn_save_disabled = false;
        this.btn_save_loader = false;
        console.log('err', err);
      });
    } else {
      console.log("Form not valid");
    }
  }

  update(item) {
    if (this.form.valid) {
      this.btn_save_disabled = true;
      this.btn_save_loader = true;

      let data = this.form.getRawValue();
      this.dataService.putAsPromise(`admin/missions/${item.id}`, data).then(res => {
        if (res && res.data) {
          this.mission.import(data);

          this.dialogRef.close({ mode: 'update' });
        } else {
          this.dialogRef.close('bt_save');
        }
        this.btn_save_disabled = false;
        this.btn_save_loader = false;
      }).catch(err => {
        this.btn_save_disabled = false;
        this.btn_save_loader = false;
        console.log('err', err);
      });
    } else {
      console.log("Form not valid");
    }
  }

  startDateValueChange(event){
    if(event && event.value){
      this.endDate = moment(event.value).add(1, 'd');
    }
  }

  hasError(controlName: string, errorName: string) {
    if (!controlName) {
      return this.form.hasError(errorName);
    }
    return this.form.controls[controlName].hasError(errorName);
  }

}
